import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideLoader, setProspectDetails, setQuoteData, showLoader } from "redux/actions";
import { AutoSuggest, TextInput, RadioGroup, CheckBox } from "components/common/FormControls";
import logger from "common/utilities/logger";
import { CatBreeds, DogBreeds } from "services/rest/breedsApi";
import { getEnvVar, normalizeZipCode } from "common/utilities/ generic";
import appConstant from "common/constants/appConstant";
import zipCodeValidationApi from "services/rest/zipCodeValidationApi";
import { get, isEmpty } from "lodash";
import { Button } from "@material-ui/core";
import ButtonLoading from "components/common/LoadingIndicator/buttonLoading";
import emailValidationApi from "services/rest/emailValidationApi";
import moment from "moment";
import Footer from "components/footer";
import { setQuotePayload } from "./helper";
import Header from "components/header";
import getProspectApi from "services/rest/getProspectApi";
import isEmail from "validator/lib/isEmail";
import { createCampaignCode } from "common/utilities/queryparams";
import cognitoApi from "services/rest/cognitoApi";
import PartnerQuoteApi from "services/rest/partnerApi";
import ROUTE_CONSTANTS from "common/constants/route";
import { useHistory } from "react-router";
import { sendAnalyticsOnEvent } from "common/utilities/analytics";
import {
    getStartQuoteClickMapping,
    getStartQuoteSubmitMapping,
} from "common/utilities/analytics/config/mappings/eventDataLayerMappings";

const MyPetForm = () => {
    const dispatch = useDispatch();
    let history = useHistory();

    const { sdkConfig, cmsData } = useSelector((state) => state.userDetails);

    const [formData, setFormData] = useState({
        petType: "DOG",
        breedId: "",
        petName: "",
        petAge: "",
        email: "",
        zipCode: "",
        marketing: true,
        isValidZip: false,
        isValidEmail: false,
    });
    const [dogBreedsData, setDogBreedsData] = useState([]);
    const [catBreedsData, setCatBreedsData] = useState([]);
    const [fieldError, setFieldError] = useState({});
    const [zipCodeData, setZipCodeData] = useState({});
    const [isEmailOptOutEnabled, setIsEmailOptOutEnabled] = useState(false);
    const [inProcess, setInProcess] = useState(false);
    const [isErrorMessage, setErrorMessage] = useState("");
    const [isApiErrorMessage, setApiErrorMessage] = useState("");
    const [isAlertMessage, setAlertMessage] = useState("");
    const [isBankMessage, setBankMessage] = useState("");
    const [isZipVerifyInProcess, setZipVerifyInProcess] = useState(false);

    const {
        quote_loader,
        tell_us_about_your_pet,
        pet_name,
        breed,
        age,
        zip_postal_code,
        get_your_free_quote,
        your_email,
        verifying_zip_code,
        loading,
        marketing,
        pet_age,
        dog_active,
        dog_inactive,
        cat_active,
        cat_inactive,
        disclaimer_yellow_icon,
        disclaimer_red_icon,
        zip_code_province,
        ky_zip_code,
        bank_error,
        api_error,
        phone_number,
        api_error_phone_number,
    } = cmsData;

    const {
        styles = {
            button: {
                active: {},
            },
        },
        label = {
            button: {
                buttonTextStep1: "",
            },
            heading: {
                headingTextStep1: "",
            },
        },
        showAppLogo = true,
        showHeadingOnStep1 = true,
        showSecondScreen = true,
        queryParams = "",
    } = sdkConfig;

    const setShowLoader = () => {
        dispatch(
            showLoader({
                isLoading: true,
                loaderMetadata: {
                    loaderAnimation: quote_loader,
                },
            })
        );
    };

    const setHideLoader = () => {
        dispatch(hideLoader({ isLoading: false }));
    };

    const checkFormInvalid = () => {
        const copyFormData = { ...formData };
        delete copyFormData.marketing;

        return Object.values(copyFormData).some((v) => v === null || `${v}`.trim() === "" || v === false);
    };

    const validateGetQuoteForm = () => {
        const isFormDataInvalid = !checkFormInvalid();

        return isFormDataInvalid && zipCodeData?.isValid && zipCodeData?.isCovered;
    };

    const getPetAge = pet_age.map((item, index) => {
        return { value: index.toString(), label: item.label };
    });

    const getDogBreeds = async () => {
        try {
            const { payload } = await DogBreeds.invoke({ countryCode: "US" });

            const breedMap = convertToMap(payload.payload.responses);

            setDogBreedsData(Object.values(breedMap));

            getCatBreeds();
        } catch (error) {
            logger.error("Error while fetching DOG breeds: ", error);
        }
    };

    const getCatBreeds = async () => {
        try {
            const { payload } = await CatBreeds.invoke({ countryCode: "US" });

            const breedMap = convertToMap(payload.payload.responses);

            setCatBreedsData(Object.values(breedMap));
        } catch (error) {
            logger.error("Error while fetching CAT breeds: ", error);
        }
    };

    const convertToMap = (obj) => {
        const updatedObj = obj.reduce((allValues, item) => {
            allValues[item.breedId] = { ...item, value: item.breedId };

            return allValues;
        }, {});

        return updatedObj;
    };

    const clearErrorMessage = () => {
        setApiErrorMessage("");
        setErrorMessage("");
        setAlertMessage("");
        setBankMessage("");
    };

    const verifyZipCode = async (zip) => {
        try {
            clearErrorMessage();
            setZipVerifyInProcess(true);
            setInProcess(true);

            var { payload } = await zipCodeValidationApi.invoke({
                zip,
                currentDateTime: moment().format(appConstant.ISO_DATE),
            });

            const data = get(payload, "payload.responses[0]", {});
            const isCovered = get(data, "isCovered", false);
            const isValid = get(data, "isValid", false);
            const state = get(data, "state", "");

            const copyFieldError = { ...fieldError };

            if (isCovered && isValid) {
                delete copyFieldError["zipCode"];
            } else {
                copyFieldError["zipCode"] = true;

                if (!isCovered) setErrorMessage(zip_code_province);
            }

            if (appConstant.BLOCK_STATE_CODE.includes(state)) {
                copyFieldError["zipCode"] = true;

                setErrorMessage(zip_code_province);

                setZipCodeData({ ...data, isCovered: false, isValid: false });
            } else if (state === appConstant.KENTUCKY_STATE_CODE) {
                copyFieldError["zipCode"] = true;

                setAlertMessage(ky_zip_code);

                setZipCodeData({ ...data, isCovered: false, isValid: false });
            } else {
                setZipCodeData(data);
            }

            setFieldError(copyFieldError);

            setInProcess(false);

            setZipVerifyInProcess(false);
        } catch (error) {
            setInProcess(false);

            setZipVerifyInProcess(false);

            const copyFieldError = { ...fieldError };

            copyFieldError["zipCode"] = true;

            setFieldError(copyFieldError);

            logger.error(`Error while verify zip code ${zip}:`, error);
        }
    };

    const handleOnChange = (e, value) => {
        setApiErrorMessage("");

        setFormData({
            ...formData,
            [value.name]: value.value,
            ...(value.name === "zipCode" && {
                isValidZip: false,
                marketing: false,
            }),
            ...(value.name === "petType" && {
                breedId: "",
            }),
        });

        if (value.name === "zipCode") {
            setZipCodeData({});
        }

        const copyFieldError = { ...fieldError };

        delete copyFieldError[value.name];

        setFieldError(copyFieldError);
    };

    const handleOnBlur = (e) => {
        const targetName = e.target.id;
        const value = e.target.value;

        const copyFieldError = { ...fieldError };

        if (value?.trim() === "") {
            copyFieldError[targetName] = true;
        } else {
            delete copyFieldError[targetName];
        }

        if (targetName === "zipCode" && !formData.isValidZip) {
            copyFieldError[targetName] = true;

            setIsEmailOptOutEnabled(false);

            setErrorMessage("");
            setAlertMessage("");
        }

        if (targetName === "zipCode" && formData.isValidZip) {
            verifyZipCode(formData.zipCode);
        }

        if (targetName === "email" && !formData.isValidEmail) {
            copyFieldError[targetName] = true;
        }

        setFieldError(copyFieldError);
    };

    const handleKeyupZipCode = (e) => {
        const value = e.target.value;

        const ZipCode = normalizeZipCode(value);

        const usPattern = new RegExp(appConstant.US_ZIP_CODE_PATTERN);
        const caPattern = new RegExp(appConstant.CAN_ZIP_CODE_PATTERN);

        const isValidZip = usPattern.test(ZipCode.toString()) || caPattern.test(ZipCode.toString().replace(/\W+/g, ""));

        setFormData({ ...formData, isValidZip });
    };

    const handleKeyupEmail = (e) => {
        const value = e.target.value;

        const isValidEmail = isEmail(value?.trim());

        setFormData({ ...formData, isValidEmail });
    };

    const GetCustomerAndProspectData = async (emailId) => {
        try {
            const { payload } = await getProspectApi.invoke(emailId);
            const { response } = payload.payload;

            dispatch(setProspectDetails({ response }));

            logger.info("Customer Exists and Prospect API Data:", JSON.stringify(response));

            return { getProspect: response, isApiSuccess: true };
        } catch (error) {
            logger.error("Error in Customer Exists API:", error);

            return { isApiSuccess: false };
        }
    };

    const checkInputFieldError = () => {
        const copyFieldError = { ...fieldError };

        if (formData.petName?.trim() === "") {
            copyFieldError["petName"] = true;
        }

        if (formData.breedId?.trim() === "") {
            copyFieldError["breedId"] = true;
        }

        if (formData.petAge?.trim() === "") {
            copyFieldError["petAge"] = true;
        }

        if (formData.email?.trim() === "" || !formData.isValidEmail) {
            copyFieldError["email"] = true;
        }

        if (formData.zipCode?.trim() === "" || !formData.isValidZip) {
            copyFieldError["zipCode"] = true;
        }

        setFieldError(copyFieldError);
    };

    const handleSubmitError = () => {
        setApiErrorMessage(api_error);

        setInProcess(false);

        setHideLoader();

        sendQuoteSubmit(api_error);
    };

    const handleSubmit = async () => {
        logger.info("form data", JSON.stringify(formData));

        let emailValidation = formData.isValidEmail;

        if (validateGetQuoteForm()) {
            setInProcess(true);
            clearErrorMessage();

            try {
                const { payload } = await emailValidationApi.invoke({ emailId: formData.email?.trim() });

                emailValidation = get(payload, "payload.responses[0].isValid", "false");

                if (!emailValidation) {
                    const copyFieldError = { ...fieldError };

                    copyFieldError["email"] = true;
                    setFieldError(copyFieldError);

                    setInProcess(false);
                }
            } catch (error) {
                emailValidation = false;

                logger.error("Error in validate email API:", error);

                handleSubmitError();
            }

            if (emailValidation) {
                getNewQuote();
            }
        } else {
            checkInputFieldError();
        }
    };

    const getNewQuote = async () => {
        setShowLoader();
        setInProcess(false);

        const { getProspect, isApiSuccess } = await GetCustomerAndProspectData(formData.email);

        if (!isApiSuccess) {
            handleSubmitError();

            return;
        }

        if (getProspect?.isPaymentOnHold) {
            setBankMessage(bank_error);

            setHideLoader();

            sendQuoteSubmit(bank_error);

            return;
        }

        const campaignCode = createCampaignCode(queryParams);

        const payload = {
            ...formData,
            zipCode: normalizeZipCode(formData.zipCode),
            petName: formData.petName?.trim(),
            email: formData.email?.trim(),
            ...zipCodeData,
            ...getProspect,
            promoCode: campaignCode,
            queryParams,
        };

        try {
            const postData = setQuotePayload(payload);

            const tokenData = await cognitoApi.invoke();

            const QuoteAPI = new PartnerQuoteApi(tokenData?.payload?.access_token);

            const result = await QuoteAPI.invoke(postData);

            const customerDetails = get(result, "payload.payload.response.customer", "");

            if (customerDetails) {
                dispatch(setQuoteData({ ...customerDetails, ...zipCodeData }));

                sendClickEvent();

                if (!showSecondScreen) {
                    const BUY_URL = getEnvVar("REACT_APP_BUY_QUOTE_URL");

                    const params = queryParams
                        ? `${queryParams}&prospectId=${customerDetails?.customerId}`
                        : `?prospectId=${customerDetails?.customerId}`;

                    const URL = `${BUY_URL}${params}`;

                    logger.info("Redirect to the BUY flow as the second screen is turned off.", URL);

                    try {
                        if (window.self !== window.top) {
                            window.parent.location.href = URL;
                        } else {
                            window.location.href = URL;
                        }
                    } catch (error) {
                        window.open(URL);

                        setHideLoader();

                        logger.error("Getting error while accessing parents URL", error);
                    }
                } else {
                    logger.info("Redirect to the step2 with prospect id:", customerDetails?.customerId);

                    history.push(ROUTE_CONSTANTS.QUOTE);
                }
            } else {
                handleSubmitError();

                logger.error("Error in create Quote API:", JSON.stringify(result));
            }
        } catch (error) {
            handleSubmitError();

            logger.error("Error in create Quote API:", error);
        }
    };

    const getDynamicBtnClass = () => {
        let btnClass = "m-50";

        if (isEmailOptOutEnabled || !!isErrorMessage || !!isAlertMessage || !!isBankMessage || !!isApiErrorMessage) {
            btnClass = "m-20";
        }

        return btnClass;
    };

    const sendClickEvent = () => {
        const mapping = getStartQuoteClickMapping();

        mapping.email = formData.email;
        mapping.zipCode = normalizeZipCode(formData?.zipCode?.toUpperCase());

        sendAnalyticsOnEvent(mapping);

        sendQuoteSubmit();
    };

    const sendQuoteSubmit = (message) => {
        const mapping = getStartQuoteSubmitMapping();

        if (message) mapping.failure_reason = message;
        mapping.pet_age = formData.petAge;
        mapping.pet_type = formData.petType;

        sendAnalyticsOnEvent(mapping);
    };

    useEffect(() => {
        if (!isEmpty(zipCodeData)) {
            const isUSZipCode =
                zipCodeData && formData.zipCode && zipCodeData?.countryCode === appConstant.COUNTRY_CODE_US;
            const isCAZipCode =
                zipCodeData && formData.zipCode && zipCodeData?.countryCode === appConstant.COUNTRY_CODE_CANADA;

            if (isUSZipCode) {
                setFormData({ ...formData, marketing: true });
                setIsEmailOptOutEnabled(false);
            }

            if (isCAZipCode) {
                setFormData({ ...formData, marketing: true });
                //setIsEmailOptOutEnabled(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zipCodeData]);

    useEffect(() => {
        getDogBreeds();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {showAppLogo && <Header />}
            <div className="myPetForm">
                <div className="myPetForm__container">
                    <div className="myPetForm__container__module-head">
                        <div className="myPetForm__container__module-head__form-container">
                            {showHeadingOnStep1 && (
                                <div className="myPetForm__container__module-head__form-container__heading">
                                    {label?.heading?.headingTextStep1 || tell_us_about_your_pet}
                                </div>
                            )}
                            {!showHeadingOnStep1 && !showAppLogo && (
                                <div className="myPetForm__container__module-head__form-container__hide-heading"></div>
                            )}
                            <div className="myPetForm__container__module-head__form-container__fieldGroup">
                                <TextInput
                                    name="petName"
                                    value={formData.petName}
                                    onChange={handleOnChange}
                                    identifier="petName"
                                    type="text"
                                    inputVariant="filled"
                                    inputLabel={pet_name}
                                    onBlur={handleOnBlur}
                                    error={fieldError["petName"]}
                                />
                            </div>
                            <div className="myPetForm__container__module-head__form-container__radioGroup">
                                <RadioGroup
                                    options={[
                                        {
                                            id: "dog",
                                            value: "DOG",
                                            label: "Dog",
                                            active_url: dog_active.url,
                                            url: dog_inactive.url,
                                        },
                                        {
                                            id: "cat",
                                            value: "CAT",
                                            label: "Cat",
                                            active_url: cat_active.url,
                                            url: cat_inactive.url,
                                        },
                                    ]}
                                    defaultValue={formData.petType}
                                    onChange={handleOnChange}
                                    name="petType"
                                />
                            </div>
                            <div className="myPetForm__container__module-head__form-container__petData">
                                <div className="myPetForm__container__module-head__form-container__petData__fieldGroup">
                                    <AutoSuggest
                                        name="breedId"
                                        value={formData.breedId}
                                        onChange={handleOnChange}
                                        identifier="breedId"
                                        options={formData.petType === "DOG" ? dogBreedsData : catBreedsData}
                                        label={breed}
                                        onBlur={handleOnBlur}
                                        dataTextField={"label"}
                                        dataValueField={"value"}
                                        error={fieldError["breedId"]}
                                    />
                                </div>
                                <div className="myPetForm__container__module-head__form-container__petData__fieldGroup">
                                    <AutoSuggest
                                        name="petAge"
                                        value={formData.petAge}
                                        onChange={handleOnChange}
                                        identifier="petAge"
                                        options={getPetAge}
                                        label={age}
                                        onBlur={handleOnBlur}
                                        dataTextField={"label"}
                                        dataValueField={"value"}
                                        error={fieldError["petAge"]}
                                    />
                                </div>
                                <div className="myPetForm__container__module-head__form-container__petData__fieldGroup">
                                    <TextInput
                                        name="zipCode"
                                        value={formData.zipCode}
                                        onChange={handleOnChange}
                                        identifier="zipCode"
                                        type="text"
                                        inputVariant="filled"
                                        inputLabel={zip_postal_code}
                                        onBlur={handleOnBlur}
                                        onKeyUp={handleKeyupZipCode}
                                        error={fieldError["zipCode"]}
                                    />
                                </div>
                                <div className="myPetForm__container__module-head__form-container__petData__fieldGroup">
                                    <TextInput
                                        name="email"
                                        value={formData.email}
                                        onChange={handleOnChange}
                                        identifier="email"
                                        type="text"
                                        inputVariant="filled"
                                        inputLabel={your_email}
                                        onBlur={handleOnBlur}
                                        onKeyUp={handleKeyupEmail}
                                        error={fieldError["email"]}
                                    />
                                </div>
                            </div>
                            {/* {isEmailOptOutEnabled && (
                                <div className="myPetForm__container__module-head__form-container__fieldGroup">
                                    <div className="myPetForm__container__module-head__form-container__checkbox-container">
                                        <CheckBox
                                            name="marketing"
                                            identifier="marketing"
                                            onChange={handleOnChange}
                                            color="default"
                                            value={formData.marketing}
                                        />
                                        <div className="accept-msg-div">
                                            <span className="accept-msg">{marketing}</span>
                                        </div>
                                    </div>
                                </div>
                            )} */}
                            {!!isErrorMessage && (
                                <div className="myPetForm__container__module-head__form-container__error-message">
                                    <img src={disclaimer_red_icon?.url} alt={disclaimer_red_icon.alt} />
                                    <span>{isErrorMessage}</span>
                                </div>
                            )}
                            {!!isApiErrorMessage && (
                                <div className="myPetForm__container__module-head__form-container__error-message">
                                    <img src={disclaimer_red_icon?.url} alt={disclaimer_red_icon.alt} />
                                    <span>
                                        {`${isApiErrorMessage} `}
                                        <a
                                            href={`tel:${phone_number}`}
                                            draggable="false"
                                            className="buy-flow-header__phone"
                                        >
                                            {api_error_phone_number}
                                        </a>
                                        {"."}
                                    </span>
                                </div>
                            )}
                            {!!isAlertMessage && (
                                <div className="myPetForm__container__module-head__form-container__error-message">
                                    <img src={disclaimer_yellow_icon?.url} alt={disclaimer_yellow_icon.alt} />
                                    <span>
                                        {`${isAlertMessage} `}
                                        <a
                                            href={`tel:${phone_number}`}
                                            draggable="false"
                                            className="buy-flow-header__phone"
                                        >
                                            {phone_number}
                                        </a>
                                        {"."}
                                    </span>
                                </div>
                            )}
                            {!!isBankMessage && (
                                <div className="myPetForm__container__module-head__form-container__error-message">
                                    <img src={disclaimer_yellow_icon?.url} alt={disclaimer_yellow_icon.alt} />
                                    <span>{`${isBankMessage} `}</span>
                                </div>
                            )}
                            <div
                                className={`myPetForm__container__module-head__form-container__buttonGroup ${getDynamicBtnClass()}`}
                            >
                                <Button
                                    type="button"
                                    size="large"
                                    onClick={handleSubmit}
                                    variant="contained"
                                    id="submit"
                                    className={inProcess ? `no-click submit-button` : "submit-button"}
                                    style={{ ...styles?.button?.active }}
                                >
                                    {inProcess ? (
                                        <span className="button-loading-content">
                                            {isZipVerifyInProcess ? verifying_zip_code : loading}
                                            <ButtonLoading />
                                        </span>
                                    ) : (
                                        <>{label?.button?.buttonTextStep1 || get_your_free_quote}</>
                                    )}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

MyPetForm.propTypes = {};

export default MyPetForm;
